import * as amplitude from "@amplitude/analytics-react-native"
import { theme } from "@common/theme/theme"
import { LinearGradient } from "expo-linear-gradient"
import React, { useContext, useState } from "react"
import { ActivityIndicator, Pressable, View } from "react-native"
import { DimensionsContext } from "../../utils/mobileUtils"
import TextM from "../text/TextM"
import withPreventDoubleClick from "../../utils/withPreventDoubleClick"

const GradientButtonM = (props) => {
    const {
        label,
        fontWeight = "SemiBold",
        trackingId,
        onPress,
        loading,
        disabled,
        icon,
        style,
        contentStyle,
        labelStyle,
    } = props
    const dimensions = useContext(DimensionsContext)

    const [isPressed, setIsPressed] = useState(false)

    const buttonWidth =
        dimensions?.width < 800 ? dimensions?.width - 40 : dimensions?.width / 2

    const handlePressIn = () => {
        if (disabled || loading) return
        setIsPressed(true)
    }

    const handlePressOut = () => {
        if (disabled || loading) return
        setIsPressed(false)
    }

    const handlePress = (e) => {
        if (disabled || loading) return
        onPress?.(e)
        if (trackingId) {
            amplitude.track("button.clicked." + trackingId)
        }
    }

    // Gradient colors - blue gradient matching the example
    const getGradientColors = (pressed) => {
        if (disabled) {
            return ["#94a3b8", "#cbd5e1", "#e2e8f0"] // Gray when disabled
        }
        return pressed
            ? ["#1e3a8a", "#2563eb", "#0284c7"] // Darker blue on press
            : ["#1e40af", "#3b82f6", "#0ea5e9"] // Blue gradient
    }

    // Use inline styles for dynamic values to avoid StyleSheet.create() issues on web
    const containerStyle = {
        borderRadius: 16,
        width: buttonWidth,
        alignSelf: "center",
        overflow: "hidden",
        shadowColor: "#3b82f6",
        shadowOffset: {
            width: 0,
            height: 4,
        },
        shadowOpacity: disabled ? 0 : 0.5,
        shadowRadius: 10,
        elevation: disabled ? 0 : 8,
    }

    const gradientStyle = {
        minHeight: contentStyle?.height || 56,
        paddingVertical: 14,
        // Le libellé s'arrête à 12 px des bords : au-delà, il passe à la ligne.
        paddingHorizontal: 12,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
        gap: 8,
    }

    // Un libellé plus large que le bouton passe à la ligne au lieu d'être
    // rogné par ses bords (un prénom dans « Réserver la place de … · 1 € »).
    const contentStyleObj = {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        zIndex: 10,
        flexShrink: 1,
    }

    return (
        <Pressable
            onPress={handlePress}
            onPressIn={handlePressIn}
            onPressOut={handlePressOut}
            disabled={disabled || loading}
            style={[containerStyle, style]}
        >
            <LinearGradient
                colors={getGradientColors(isPressed)}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
                style={[gradientStyle, contentStyle]}
            >
                <View style={contentStyleObj}>
                    {loading ? (
                        <ActivityIndicator
                            size="small"
                            color={theme.colors.white}
                        />
                    ) : (
                        icon && <View style={{ marginRight: 4 }}>{icon}</View>
                    )}
                    <TextM
                        color={theme.colors.white}
                        fontWeight={fontWeight}
                        style={{ flexShrink: 1, ...labelStyle }}
                        fontSize={18}
                        wrap
                        center
                    >
                        {label}
                    </TextM>
                </View>
            </LinearGradient>
        </Pressable>
    )
}

export default withPreventDoubleClick(GradientButtonM)
